import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, createContext, useContext, useEffect, useState } from "react";
import { type FormMode, FormModeValues } from "types/formMode";
const FormModeContext = createContext({} as FormMode);
export const useFormMode = () => {
  return useContext(FormModeContext);
};
export function FormModeProvider(t0) {
  const $ = _c(6);
  const {
    mode: t1,
    children
  } = t0;
  const mode = t1 === undefined ? FormModeValues.Form : t1;
  const [stateValue, setMode] = useState("Form");
  let t2;
  let t3;
  if ($[0] !== mode) {
    t2 = () => {
      setMode(mode);
    };
    t3 = [mode];
    $[0] = mode;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== children || $[4] !== stateValue) {
    t4 = <FormModeContext.Provider value={stateValue}>{children}</FormModeContext.Provider>;
    $[3] = children;
    $[4] = stateValue;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}